import { RoundingRule, RoundingRuleMutationPayload } from 'repository/timekeeper/@types/RoundingRules';

export class RoundingRulesRepo {
    private httpService: IHttpService;
    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getRoundingRules(): Promise<RoundingRule[]> {
        try {
            const response = await this.httpService.get<TKResponse<RoundingRule[]>>('/rounding_rules');
            return response.data
                .map((item: RoundingRule) => ({ ...item, id: item.rounding_rule_id }))
                .sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
        } catch (error) {
            console.error('Error fetching rounding rules:', error);
            throw error;
        }
    }

    async getRoundingRuleById(id: number): Promise<RoundingRule> {
        const response = await this.httpService.get<RoundingRule>(`/rounding_rules/${id}`);
        return { ...response, id: response.rounding_rule_id };
    }
    async createRoundingRule(data: RoundingRuleMutationPayload): Promise<RoundingRule> {
        return this.httpService.post<RoundingRule, RoundingRuleMutationPayload>('/rounding_rules', { data });
    }
    async updateRoundingRule(id: number, data: RoundingRuleMutationPayload): Promise<RoundingRule> {
        return this.httpService.patch<RoundingRule, RoundingRuleMutationPayload>(`/rounding_rules/${id}`, { data });
    }
    async deleteRoundingRule(id: number): Promise<any> {
        return this.httpService.delete(`/rounding_rules/${id}`);
    }
}
